import { create } from 'zustand';

export type ToastKind = 'info' | 'success' | 'error';

export interface Toast {
  id: number;
  kind: ToastKind;
  message: string;
  action?: { label: string; run: () => void } | undefined;
}

interface ToastState {
  toasts: Toast[];
  push: (message: string, kind?: ToastKind, action?: Toast['action']) => void;
  dismiss: (id: number) => void;
}

let seq = 0;

export const useToasts = create<ToastState>((set, get) => ({
  toasts: [],
  push: (message, kind = 'info', action) => {
    const id = ++seq;
    set({ toasts: [...get().toasts, { id, kind, message, action }] });
    setTimeout(() => { get().dismiss(id); }, kind === 'error' ? 7000 : 4000);
  },
  dismiss: (id) => { set({ toasts: get().toasts.filter((t) => t.id !== id) }); },
}));

export const toast = {
  info: (m: string) => { useToasts.getState().push(m, 'info'); },
  success: (m: string) => { useToasts.getState().push(m, 'success'); },
  error: (m: unknown) => {
    const message = m instanceof Error ? m.message : String(m);
    useToasts.getState().push(message, 'error');
  },
};
